import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { 
  IonTabBar, 
  IonTabButton, 
  IonTabs, 
  // IonLabel, 
  IonIcon, 
  IonPage, 
  IonRouterOutlet
} from '@ionic/vue';
import { searchOutline, starOutline, personCircleOutline, homeOutline } from 'ionicons/icons';
import router from '@/router';
import IconBtn from '@/components/IconBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsPage',
  setup(__props) {

const to = (path = '/') => {
  router.push(path);
}


return (_ctx: any,_cache: any) => {
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          (['/app/profile'].includes(_unref(router).currentRoute.value.path))
            ? (_openBlock(), _createBlock(_component_List, {
                key: 0,
                el: "column-stretch xxsm",
                id: "bottomNavBar"
              }, {
                default: _withCtx(() => [
                  _createVNode(IconBtn, {
                    name: "star",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (to('/app/saved')))
                  }),
                  _createVNode(IconBtn, { name: "public" }),
                  _createVNode(IconBtn, { name: "share" }),
                  _createVNode(IconBtn, { name: "store" })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_List, {
                key: 1,
                el: "column-stretch xxsm",
                id: "bottomNavBar"
              }, {
                default: _withCtx(() => [
                  (_unref(router).currentRoute.value.path == '/app/home')
                    ? (_openBlock(), _createBlock(IconBtn, {
                        key: 0,
                        name: "star",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (to('/app/saved')))
                      }))
                    : (_openBlock(), _createBlock(IconBtn, {
                        key: 1,
                        name: "home",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (to('/app/home')))
                      })),
                  _createVNode(IconBtn, {
                    name: "search",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (to('/app/search'))),
                    class: _normalizeClass({active: _unref(router).currentRoute.value.path == '/app/search'})
                  }, null, 8, ["class"]),
                  _createVNode(IconBtn, {
                    name: "account_circle",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (to('/app/account'))),
                    class: _normalizeClass({active: _unref(router).currentRoute.value.path == '/app/account'})
                  }, null, 8, ["class"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})